import { render, staticRenderFns } from "./HolidaysYearGroup.vue?vue&type=template&id=74fe09bd"
import script from "./HolidaysYearGroup.vue?vue&type=script&lang=js"
export * from "./HolidaysYearGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports